import { graphql, useLazyLoadQuery } from 'react-relay';
import { expVal } from '@atlassian/jira-feature-experiments';
import { functionWithCondition } from '@jira/platform__utils-feature-flagging-utils/src/utils/function-with-condition/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import type { useInitialPanelWidthQuery as TQuery } from './__generated__/useInitialPanelWidthQuery.graphql.ts';

const useInitialPanelWidthEnabled = (): number | undefined => {
	const cloudId = useCloudId();
	const data = useLazyLoadQuery<TQuery>(
		graphql`
			query useInitialPanelWidthQuery($cloudId: ID!) {
				jira {
					navigationUIState(cloudId: $cloudId) {
						previewPanel {
							width
						}
					}
				}
			}
		`,
		{ cloudId },
		{ fetchPolicy: 'store-only' },
	);
	return data?.jira?.navigationUIState?.previewPanel?.width ?? undefined;
};

const useInitialPanelWidthDisabled = (): number | undefined => undefined;

export const useInitialPanelWidth: () => number | undefined = functionWithCondition(
	() => expVal('nin_glance_panel', 'isEnabled', false),
	useInitialPanelWidthEnabled,
	useInitialPanelWidthDisabled,
);
